module.exports = __webpack_public_path__ + "static/media/electric-energy.10540e81.svg";